import React, { useState, useEffect } from "react";
import closeImg from "../Resources/svg/cancel.svg";
import { API } from "aws-amplify";
import { DualRing } from "react-loading-io";
import ErrorCustom from "./errorCustom";
import { validatorField, validateNumberField, validateTextOnlyAlphanumeric } from "../Utils/validators";
import { useForm } from "react-hook-form";

export default function ModalAddress({ open, setOpen, setAddress }) {
  const {handleSubmit, register, errors} = useForm();
  const [department, setDepartment] = useState(null);
  const [dataDepart, setDataDepart] = useState([]);
  const [dataProv, setDataProv] = useState([]);
  const [dataDist, setDataDist] = useState([]);
  const [nameUbigeo, setNameUbigeo] = useState({
    province: "",
    department: "",
    district: ""
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUbigeos(null, null, null);
  }, []);

  const getUbigeos = async(depart, prov, filterBy) => {
    setLoading(true);
    let params = {};
    if (depart) {
      params.department = depart;
    }
    if (prov) {
      params.province = prov;
    }

    const response = await API.post("api-rentas", "/ubigeos", {
      body: params,
      headers: {}
    });

    if (response.status) {
      const { data } = response;
      if (filterBy === "department") {
        setDataProv(data);
        setDataDist([]);
        setDepartment(depart);
      }
      else if(filterBy === "province") {
        setDataDist(data);
      }
      else {
        setDataDepart(data);
      }
    }
    setLoading(false);
  }

  const handleChangeDepart = (e) => {
    const depart = e.target.value;
    const index = e.target.selectedIndex;
    const nameDepart = e.target[index].text;
    setNameUbigeo({
      ...nameUbigeo,
      department: nameDepart
    });
    getUbigeos(depart, null, "department");
  }

  const handleChangeProv = (e) => {
    const prov = e.target.value;
    const index = e.target.selectedIndex;
    const nameProv = e.target[index].text;
    setNameUbigeo({
      ...nameUbigeo,
      province: nameProv
    });
    getUbigeos(department, prov, "province");
  }

  const handleChangeDist = (e) => {
    const index = e.target.selectedIndex;
    const nameDist = e.target[index].text;
    setNameUbigeo({
      ...nameUbigeo,
      district: nameDist
    });
  }

  const onSubmit = (values) => {
    const data = {
      ...values,
      nameUbigeo
    };
    setAddress(data);
    setOpen(false);
  }

  return (
    <div className={`md-g-wapper ${open ? "md-g-open" : ""}`}>
      <div className="modalAddress md-g-wapper__container">
        <img
            src={closeImg}
            alt="imgClose"
            className="md-g-wapper__container__button-close"
            onClick={() => setOpen(false)}
          />
        <div className="title">
          <p>Agregar dirección</p>
        </div>
        <div className="addressForm">
          <p>Completa los campos para agregar una nueva dirección:</p>
          {loading && (
            <div className="loading-field">
              <DualRing size={50} />
            </div>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="addressForm__item">
              <select 
                name="department"
                onChange={e => handleChangeDepart(e)}
                ref={register({ validate: validatorField })}
              >
                <option value="">Departamento</option>
                {dataDepart.map((item, index) => 
                  <option value={item.codigo} key={index}>{item.descripcion}</option>
                )}
              </select>
              <ErrorCustom errors={errors} name="department" />
            </div>
            <div className="addressForm__item">
              <select 
                name="province"
                onChange={e => handleChangeProv(e)}
                ref={register({ validate: validatorField })}
              >
                <option value="">Provincia</option>
                {dataProv.map((item, index) => 
                  <option value={item.codigo} key={index}>{item.descripcion}</option>
                )}
              </select>
              <ErrorCustom errors={errors} name="province" />
            </div>
            <div className="addressForm__item">
              <select 
                name="district"
                onChange={e => handleChangeDist(e)}
                ref={register({ validate: validatorField })}
              >
                <option value="">Distrito</option>
                {dataDist.map((item, index) => 
                  <option value={item.codigo} key={index}>{item.descripcion}</option>
                )}
              </select>
              <ErrorCustom errors={errors} name="district" />
            </div>
            <div className="addressForm__item description">
              <div>
                <select 
                  name="type"
                  ref={register({ validate: validatorField })}
                >
                  <option value="AL">ALAMEDA</option>
                  <option value="AV">AVENIDA</option>
                  <option value="BJ">BAJADA</option>
                  <option value="BL">BOULEVARD</option>
                  <option value="CL">CALLE</option>
                  <option value="N">CALLEJÓN</option>
                  <option value="CA">CARRETERA</option>
                  <option value="R">COOPERATIVA</option>
                  <option value="E">ESQUINA</option>
                  <option value="F">FUNDO</option>
                  <option value="GA">GALERIA</option>
                  <option value="H">HACIENDA</option>
                  <option value="JR">JIRON</option>
                  <option value="KM">KILOMETRO</option>
                  <option value="ML">MALECON</option>
                  <option value="MZ">MZ</option>
                  <option value="OT">OTROS</option>
                  <option value="OV">OVALO</option>
                  <option value="PQ">PARQUE</option>
                  <option value="PJ">PASAJE</option>
                  <option value="PS">PASEO</option>
                  <option value="PL">PLAZA</option>
                  <option value="Z">PLAZUELA</option>
                  <option value="PR">PROLONGACION</option>
                  <option value="Y">PUEBLOJOVEN</option>
                  <option value="PT">PUENTE</option>
                  <option value="K">TAMBO</option>
                  <option value="I">VILLA</option>
                </select>
              </div>
              <input 
                type="text"
                autoComplete="off"
                placeholder="Dirección"
                name="name"
                ref={register({ validate: validateTextOnlyAlphanumeric })}
                minLength="2"
                maxLength="50"
              />
            </div>
            <ErrorCustom errors={errors} name="name" />

            <div className="addressForm__item">
              <input 
                type="text"
                autoComplete="off"
                placeholder="Nro/Mz/Lote"
                name="number"
                ref={register({ validate: validateNumberField })}
                maxLength="15"
              />
              <ErrorCustom errors={errors} name="number" />
            </div>
            <div className="addressForm__item">
              <input 
                type="text"
                autoComplete="off"
                placeholder="Dpto/Interior"
                name="apartment"
                ref={register({ validate: validateTextOnlyAlphanumeric })}
                maxLength="15"
              />
              <ErrorCustom errors={errors} name="apartment" />
            </div>
            <div className="addressForm__item">
              <input 
                type="text"
                autoComplete="off"
                placeholder="Urbanización"
                name="urbanization"
                ref={register({ validate: validateTextOnlyAlphanumeric })}
                maxLength="50"
              />
              <ErrorCustom errors={errors} name="urbanization" />
            </div>
            <div className="addressForm__item">
              <input 
                type="text"
                autoComplete="off"
                placeholder="Referencia"
                name="reference"
                ref={register({ validate: validateTextOnlyAlphanumeric })}
                maxLength="50"
              />
              <ErrorCustom errors={errors} name="reference" />
            </div>
            <div className="addressForm__actions">
              <button
                className="buttonCustom md cancel"
                type="button"
                onClick={() => setOpen(false)}
              >
                Cancelar
              </button>
              <button
                className="buttonCustom md"
                type="submit"
              >
                Agregar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
